var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.647,
    height: 50.647,
    viewBox: "0 0 50.647 50.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-circle-down",
    "data-name": "Icon awesome-arrow-circle-down",
    d: "M51.209,25.886A25.323,25.323,0,1,1,25.886.562,25.319,25.319,0,0,1,51.209,25.886ZM36.546,22.935l-7.393,7.709V12A2.445,2.445,0,0,0,26.7,9.548H25.069A2.445,2.445,0,0,0,22.618,12V30.644l-7.393-7.709a2.453,2.453,0,0,0-3.5-.041L10.61,24.017a2.441,2.441,0,0,0,0,3.462l13.54,13.55a2.441,2.441,0,0,0,3.462,0l13.55-13.55a2.441,2.441,0,0,0,0-3.462l-1.113-1.123a2.453,2.453,0,0,0-3.5.041Z",
    transform: "translate(51.209 -0.563) rotate(90)",
    fill: "#51aabc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.a79a117d.svg";
export { ForwardRef as ReactComponent };